import React, { useEffect, useState } from 'react';
import { Table, Space, Tooltip, Select, Modal, message } from 'antd';
import { EditOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../../../firebase-config';
import FormCourse from '../FormCourse/FormCourse';
import ButtonComponent from '../../../CssComponents/ButtonComponent/ButtonComponent';
import styles from '../../../../styles/LmsList.module.css';
import arLogo from "../../../../logo.webp"

function ListCourse() {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const [filterType, setFilterType] = useState('all');

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, 'lms_course'));
                const data = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setCourses(data);
            } catch (error) {
                console.error('Error fetching Courses:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchCourses();
    }, []);

    const handleCreateCourse = () => {
        setInitialValues({});
        setShowForm(true);
    };

    const handleEditCourse = (course) => {
        setInitialValues(course);
        setShowForm(true);
    };

    // Add delete handler
    const handleDeleteCourse = async (courseId) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this course?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                    await deleteDoc(doc(db, 'lms_course', courseId));
                    message.success('Course deleted successfully');
                    setCourses(prev => prev.filter(c => c.id !== courseId));
                } catch (error) {
                    console.error('Error deleting course:', error);
                    message.error('Failed to delete course: ' + error.message);
                }
            },
        });
    };

    const columns = [
        {
            title: 'Banner',
            dataIndex: 'courseBanner',
            key: 'courseBanner',
            render: url => (
                <img
                    src={url || arLogo}
                    alt="Course Banner"
                    style={{ width: 60, height: 40, objectFit: 'cover', borderRadius: 4 }}
                />
            ),
        },
        {
            title: 'Course Name',
            dataIndex: 'courseName',
            key: 'courseName',
            render: text => text || 'Untitled Course',
        },
        {
            title: 'Description',
            dataIndex: 'courseDescription',
            key: 'courseDescription',
            render: text => text || 'No description available.',
        },
        {
            title: 'Type',
            dataIndex: 'courseType',
            key: 'courseType',
            render: type => type === 'digital' || type === 'course_dp' ? 'Digital' : type === 'live' || type === 'course_lc' ? 'Live' : '-',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <EditOutlined
                            onClick={() => handleEditCourse(record)}
                        />
                    </Tooltip>
                    <Tooltip title="View">
                        <EyeOutlined
                            onClick={() => handleEditCourse(record)}
                        />
                    </Tooltip>
                    <Tooltip title="Delete">
                        <DeleteOutlined
                            onClick={() => handleDeleteCourse(record.id)}
                            style={{ color: 'red' }}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    // Filtering logic (if courseType is not present, this will show all)
    const filteredCourses = filterType === 'all'
        ? courses
        : courses.filter(course => (filterType === 'digital' ? (course.courseType === 'digital' || course.courseType === 'course_dp') : (course.courseType === 'live' || course.courseType === 'course_lc')));

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.heading}>Available Courses</div>
                <ButtonComponent
                    onClick={handleCreateCourse}
                    buttonText={"Create New Course"}
                />
            </div>
            {/* Filter Dropdown */}
            <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
                <span>Filter by Type:</span>
                <Select
                    value={filterType}
                    onChange={setFilterType}
                    style={{ width: 160 }}
                    options={[
                        { label: 'All', value: 'all' },
                        { label: 'Digital', value: 'digital' },
                        { label: 'Live', value: 'live' },
                    ]}
                />
            </div>
            <Table
                dataSource={filteredCourses}
                columns={columns}
                rowKey="id"
                loading={loading}
                pagination={{ pageSize: 8 }}
            />
            {showForm && (
                <FormCourse
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                    showForm={showForm}
                    onClose={() => setShowForm(false)}
                />
            )}
        </div>
    );
}

export default ListCourse;
